import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { createFn, editFn } from 'api/org/position'
import { createFn, editFn,
// getCsrfTokenFn, // 获取csrf token
getJobLeaveFn as _getJobLeaveFn,
// 获取职等列表
getLeaveFn as _getLeaveFn // 获取职级
} from 'api/org/position';
var dataForm = {
  id: '',
  job_title_name: '',
  job_title_type: '',
  description: '',
  grade_id: '',
  rank_id: ''
};
export default {
  props: {
    typeArr: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      visible: false,
      disabled: false,
      dataForm: dataForm,
      dataRule: {
        job_title_name: [{
          required: true,
          message: this.$t('90')
        }],
        job_title_type: [{
          required: true,
          message: this.$t('221')
        }],
        description: [{
          required: true,
          message: this.$t('90')
        }]
      },
      job: {
        leave: [],
        grade: []
      }
    };
  },
  methods: {
    init: function init(item) {
      var _this = this;
      this.visible = true;
      if (item) item.job_title_type = Number(item.job_title_type);
      this.getJobLeaveFn();
      this.getLeaveFn();
      this.$nextTick(function () {
        _this.dataForm = item ? JSON.parse(JSON.stringify(item)) : JSON.parse(JSON.stringify(dataForm));
        _this.$refs.dataForm.resetFields();
        _this.$nextTick(function () {
          return _this.$refs.dataForm.clearValidate();
        });
      });
    },
    // 获取职等
    getJobLeaveFn: function getJobLeaveFn() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _getJobLeaveFn();
            case 2:
              res = _context.sent;
              _this2.job.grade = res.data.list;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 获取职级
    getLeaveFn: function getLeaveFn() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _getLeaveFn();
            case 2:
              res = _context2.sent;
              _this3.job.leave = res.data.list;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this4 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this4.disabled = true;
          (_this4.dataForm.id ? editFn : createFn)(_this4.dataForm).then(function (res) {
            _this4.disabled = false;
            if (res && res.code === 1) {
              _this4.visible = false;
              _this4.$emit('refreshTableData');
              _this4.$message.success(res.message);
            }
          }).catch(function () {
            _this4.visible = false;
            _this4.disabled = false;
          });
        }
      });
    }
  }
};